var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('top-bar'),_c('div',{staticClass:"page-wrapper",class:{
      'no-sidebar': !_vm.isSidebarEnabled,
      'sidebar-minimized': _vm.isSidebarMinimized,
    }},[(_vm.isSidebarEnabled)?_c('nav-sidebar'):_vm._e(),_c('router-view'),_c('cookie-bar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }